import React, { Component } from 'react'
import propTypes from 'prop-types'
import { connect } from 'react-redux'
import { getTranslation, getTotalPages } from '@/store/getters'

import styles from './styles.scss'

/** Components */
import Select from '@/components/Select'

class LinkPage extends Component {
  state = {
    page: 0
  }

  componentDidMount() {
    const { page } = this.props
    this.setState({ page })
  }

  handleUnityPage = e => {
    // this.setState(e.target.value, () => this.props.onChange(this.state))
    // e.target.value = ''
  }

  handlePage = page => this.setState({ page }, () => this.props.onChange(this.state))

  render() {
    const { translation, totalPages } = this.props
    const { page } = this.state

    const pages = [...Array(totalPages + 1).keys()].slice(1)

    return (
      <div className={styles['wrapper-link-page']}>
        {/* <select className='ba-select ba-w-100' onChange={e => this.handlePage(e.target.value)} value={page}>
          <option value="">
            {translation('link-page-not-select')}
          </option>
          {pages.map(singlePage => (
            <option value={singlePage} key={singlePage}>
              {singlePage}
            </option>
          ))}
        </select> */}

        <div className="ba-flex ba-jc-center">
          <button class='ba-btn ba-btn-normal ba-sm ba-rounded'
            onClick={() => this.handlePage(page - 1)}
            disabled={page == 0}>
            <builderall-icon code='arrow-left'></builderall-icon>
          </button>
          <input type="text" className={"ba-input ba-mg-x-1 ba-text-center " + styles['input-pages']}
            readOnly placeholder={'Page ' + page + '/' + totalPages} />
          <button class='ba-btn ba-btn-normal ba-sm ba-rounded'
            onClick={() => this.handlePage(page + 1)}
            disabled={page == totalPages}>
            <builderall-icon code='arrow-right'></builderall-icon>
          </button>
        </div>
      </div>
    )
  }
}


LinkPage.propTypes = {
  page: propTypes.number,
  onChange: propTypes.func,
}

LinkPage.defaultProps = {
  page: 0,
  onChange: () => { }
}

const mapStateToProps = state => {
  const translation = getTranslation(state)
  const totalPages = getTotalPages(state)
  return {
    translation,
    totalPages
  }
}

export default connect(mapStateToProps)(LinkPage)


// WEBPACK FOOTER //
// ./src/components/LinkPage/index.js